import React, { useState } from 'react';
import CModal from 'components/v1/modal';
import Button from 'components/v1/Button';
import { ReactComponent as IconX } from 'assets/x-black.svg';
import { useGetDetailInvoice, useGetListVoucher } from 'api/invoice/query';
import { useApplyVoucher } from 'api/invoice/mutation';
import Loader from 'components/molecules/Loader';
import { useGlobalCtx } from 'contexts';
import { toast } from 'react-toastify';

const formatRupiah = (number) => {
  if (!number) return '0';
  let num = parseInt(number).toString();

  return 'Rp' + num.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

const ModalDetailBayarTraining = ({ onSubmit, onRequestClose, selectedInvoice, ...props }) => {
  const { profile } = useGlobalCtx()
  const officeId = profile?.company?.name

  const [selectedVoucher, setSelectedVoucher] = useState(null)
  const [appliedVoucher, setAppliedVoucher] = useState(null)
console.log(appliedVoucher)
  const { data: detailInvoice, isLoading } = useGetDetailInvoice({ id: selectedInvoice?.id })

  const invoiceData = detailInvoice?.data?.data ?? {};

  const { data: voucherList, isLoading: isLoadingVoucher } = useGetListVoucher({
    params: {
      office_valid: officeId,
      training_valid: invoiceData?.training_name
    },
    options: {
      enabled: !!officeId && !!invoiceData?.training_name
    }
  })
  const voucherData = voucherList?.data?.data ?? [];

  const { mutate: applyVoucher, isLoading: isLoadingApplyVoucher } = useApplyVoucher()

  const handleApplyVoucher = (voucher) => {
    const data = {
      voucher_discount: voucher?.code
    }
    if (!voucher?.code) delete data.voucher_discount

    applyVoucher({
      id: selectedInvoice?.id,
      data
    }, {
      onSuccess: (res) => {
        setAppliedVoucher(res?.data?.data)
        setSelectedVoucher(voucher)
      },
      onError: (error) => {
        toast.error(error?.message)
      }
    })
  }

  const handleParticipantDiscount = (participant) => {
    let participantData = appliedVoucher?.training_batch_participant_users?.find((d) => d.user_id === participant?.user_id)
    if (!participantData) return null
    return participantData.price
  }

  if (isLoading) return <div className='fixed z-50 w-screen h-screen top-0 left-0 flex items-center justify-center bg-[rgba(0,0,0,0.4)]'><Loader /></div>;

  return (
    <CModal {...props}>
      <div className="w-[740px] rounded-[6px] bg-white">
        {/* Header */}
        <div className="flex items-center justify-between px-6 pt-[18px] pb-2 border-b border-[#D8D8D9]">
          <p className="text-[20px] font-semibold text-[#252427]">Ringkasan Tagihan</p>
          <button onClick={onRequestClose} className="w-[28px] h-[28px] flex items-center justify-center rounded hover:bg-gray-100">
            <IconX width="14px" height="14px" className="text-[#808188]" />
          </button>
        </div>
        {/* Body */}
        <div className="flex gap-6 max-h-[324px] overflow-y-auto hide-scrollbar">
          {/* Left: Invoice */}
          <div className="px-6 py-6 flex-1 h-full min-w-0">
            {/* Training & Jadwal */}
            <div className="mb-2">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-[13px] text-[#808188] tracking-[-0.4px]">Training:</span>
                <span className="text-[13px] font-semibold text-[#252427] tracking-[-0.4px]">{invoiceData.training_name}</span>
              </div>
              <div className="flex items-center gap-2 mb-2">
                <span className="text-[13px] text-[#808188] tracking-[-0.4px]">Jadwal:</span>
                <span className="text-[13px] font-semibold text-[#252427] tracking-[-0.4px]">{invoiceData.training_date}</span>
              </div>
              <div className="border-t border-dashed border-[#D8D8D9] my-2" style={{ borderWidth: 0.5 }} />
            </div>
            {/* Deskripsi */}
            <div className="mb-4">
              <div className="text-[13px] font-semibold text-[#252427] tracking-[-0.4px] mb-1">Deskripsi</div>
              <div className="text-[13px] text-[#252427] tracking-[-0.4px]">
                {invoiceData.description}
              </div>
            </div>
            {/* Rincian Biaya */}
            <div className="mb-6">
              <div className="text-[13px] font-semibold text-[#252427] tracking-[-0.4px] mb-1">Rincian Biaya</div>
              <div className="overflow-x-auto">
                <table className="w-full text-[13px] border border-gray-200 rounded-lg overflow-hidden">
                  <thead>
                    <tr className="text-[#808188] font-normal bg-gray-50">
                      <th className="text-left w-[40px] py-2 pl-0 border-b border-gray-200">No.</th>
                      <th className="text-left py-2 border-b border-gray-200">Nama</th>
                      <th className="text-right py-2 pr-0 border-b border-gray-200">Biaya (Rp)</th>
                    </tr>
                  </thead>
                  <tbody className="text-[#252427]">
                    {invoiceData.training_batch_participant_users?.map((row, idx) => {
                      const discount = handleParticipantDiscount(row)
                      return (
                        <tr key={row.user_id} className="bg-white">
                          <td className="pl-0 py-2 align-top border-b border-gray-200">{idx + 1}.</td>
                          <td className="py-2 align-top border-b border-gray-200">{row?.name}</td>
                          {discount !== undefined && discount !== null ? <td className="pr-0 py-2 align-top text-right border-b border-gray-200"><span className="line-through">{formatRupiah(row?.price)}</span> {formatRupiah(discount)}</td> : <td className="pr-0 py-2 align-top text-right border-b border-gray-200">{formatRupiah(row?.price)}</td>}
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {/* Right: Diskon */}
          <div className="px-6 py-6 flex-1 h-full min-w-0 bg-[#E6E7E8] p-4 flex flex-col gap-3">
            <div className="text-[16px] font-semibold text-[#252427] mb-2">Diskon</div>
            {voucherData?.map((d, idx) => (
              <div key={idx} className={`bg-white rounded-[6px] p-3 flex flex-col gap-1 shadow-sm border ${selectedVoucher?.id === d?.id ? "border-[#252526]" : "border-[#E5E5E7]"}`}>
                <div className="flex items-center justify-between border-b border-[#D8D8D9] border-dashed">
                  <div>
                    <p className="text-[14px] font-bold text-[#252427] mb-1">Potongan <span>{d.total_discount}%</span> untuk <span>{d.kouta} orang</span></p>
                    <p className="text-[12px] text-[#808285]">{d.training_valid}</p>
                  </div>
                  {
                    selectedVoucher?.id === d?.id ? <Button size="xs" type="negative" className="!bg-white" onClick={() => {
                      setSelectedVoucher(null)
                      setAppliedVoucher(null)
                    }} text="Batalkan" /> : <Button size="xs" onClick={() => { handleApplyVoucher(d) }} text="Gunakan" />
                  }
                </div>
                <div className="flex items-center justify-between mt-2">
                  <span className="text-[12px] text-[#808285] italic">Berlaku hingga {d.end_date}</span>
                  <span className="text-[12px] text-[#808285] italic">kuota tersisa {d.kouta_available}/{d.kouta}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* Footer */}
        <div className="flex items-center justify-between px-6 py-3 border-t border-[#D8D8D9] rounded-b">
          <div className="hidden md:block">
            <p className="text-[11px] leading-[17.8px] tracking-[-0.4px] text-[#808188] mb-0.5">Total Pembayaran</p>
            {appliedVoucher?.final_amount !== undefined && appliedVoucher?.final_amount !== null ? (
              <p className="text-[17px] leading-[27.5px] tracking-[-0.4px] font-semibold text-[#252427]"><s className='line-through text-[#808285] mr-2'>{formatRupiah(invoiceData.amount)}</s>{formatRupiah(appliedVoucher?.final_amount)}</p>
            ) : (
              <p className="text-[17px] leading-[27.5px] tracking-[-0.4px] font-semibold text-[#252427]">{formatRupiah(invoiceData.amount)}</p>
            )}
          </div>
          <Button onClick={() => { onSubmit(selectedInvoice?.id, selectedVoucher?.code) }} text="Bayar Sekarang" />
        </div>
      </div>
    </CModal>
  );
};

export default function Wrapper({ isOpen, ...props }) {
  if (!isOpen) return null;
  return <ModalDetailBayarTraining isOpen={isOpen} {...props} />;
}